// import googleAnalytics from './googleAnalytics'
import { crispTrack } from './crisp'
import pixel from './pixel'

export default function (params) {
  // googleAnalytics(params)
  crispTrack(params)
  pixel(params)
}



// WEBPACK FOOTER //
// ./src/App/helpers/track/index.js